// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const handelsreg: CountryValidator<"DE"> = createValidator(
  "de.handelsreg",
  51,
);

export default handelsreg;
export const compact = handelsreg.compact;
export const format = handelsreg.format;
export const validate = handelsreg.validate;
export const generate = (): string =>
  handelsreg.generate?.() ??
  (() => {
    throw new Error(
      "Validator de.handelsreg cannot generate values",
    );
  })();
